import { Card, CardContent, CardHeader, CardTitle } from '@travellegacy/nexops-design-system';
import { BarChart3 } from 'lucide-react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

interface ActivityChartProps {
  data?: Array<{ date: string; success: number; error: number }>;
}

export function ActivityChart({ data: activityData }: ActivityChartProps) {
  // Não precisa mais de loading state - recebe dados via props

  // Converter dados para formato do gráfico com nomes de dias da semana
  const dayNames = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
  const chartData =
    activityData?.map((item: { date: string; success: number; error: number }) => {
      const date = new Date(item.date);
      const dayName = dayNames[date.getDay()];
      return {
        name: dayName,
        success: item.success,
        error: item.error,
      };
    }) || [];

  // Tooltip customizado para ficar de acordo com o theme
  const CustomTooltip = ({
    active,
    payload,
  }: {
    active?: boolean;
    payload?: Array<{ value: number; payload: { name: string } }>;
  }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-medium text-foreground mb-2">{payload[0].payload.name}</p>
          <p className="text-sm text-green-600 dark:text-green-400">Sucesso: {payload[0].value}</p>
          {payload[1] && (
            <p className="text-sm text-red-600 dark:text-red-400">Erro: {payload[1].value}</p>
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <BarChart3 className="mr-2 h-5 w-5" />
          Atividade (Últimos 7 dias)
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <Bar dataKey="success" fill="#10b981" name="Sucesso" />
            <Bar dataKey="error" fill="#ef4444" name="Erro" />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
